import { useQuery } from '@tanstack/react-query';
import { useLocation } from 'react-router-dom';
import { ApiConfig } from '@/config/api.config';
import { useAxiosAuth } from '@/hooks/useAxiosAuth';
import { SuperAdminBookingListItemDto } from '@/features/superAdmin/features/data/types/superAdmin-data.types';

type LocationState = {
    booking?: SuperAdminBookingListItemDto;
};

export const useSuperAdminBookingDetailApi = (id?: string) => {
    const axiosInstance = useAxiosAuth();
    const location = useLocation();
    const locationState = location.state as LocationState | null;
    const stateBooking = locationState?.booking;
    const placeholderBooking = stateBooking?.id === id ? stateBooking : undefined;

    const { data, isLoading, error } = useQuery({
        queryKey: [ApiConfig.queries.superAdmin.data.bookings.queryKeys.detail, id],
        enabled: Boolean(id),
        placeholderData: placeholderBooking,
        queryFn: async (): Promise<SuperAdminBookingListItemDto> => {
            const response = await axiosInstance.get<SuperAdminBookingListItemDto>(
                `${ApiConfig.queries.superAdmin.data.bookings.endpoints.detail}/${id}`,
            );
            return response.data;
        },
    });

    return {
        booking: data,
        isLoading,
        error,
    };
};
